import { Dialog, Text, COLORS } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";

import { User } from "src/store/user/types";
import { useDeleteUserMutation } from "src/store/user/api";

interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  user: User | null;
}

export function DeleteUserDialog({
  open,
  onClose,
  user,
}: DeleteUserDialogProps) {
  const [deleteUser, { isLoading }] = useDeleteUserMutation();

  const onSubmit = () => {
    if (!user) return;

    deleteUser({ id: user.id })
      .unwrap()
      .then(() => {
        toast.success("User deleted successfully");
        onClose();
      })
      .catch((e) => {
        toast.error(`${e?.status} - ${JSON.stringify(e?.data)}`);
      });
  };

  if (!user) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Delete User"
      buttonActions={[
        {
          label: "Cancel",
          onClick: onClose,
          variant: "secondary",
          size: "small",
          disabled: isLoading,
        },
        {
          label: isLoading ? "Deleting..." : "Delete",
          onClick: onSubmit,
          loading: isLoading,
          size: "small",
          sx: {
            backgroundColor: COLORS.SATURATED_RED,
            "&:hover": {
              backgroundColor: COLORS.SATURATED_RED,
              opacity: 0.9,
            },
          },
        },
      ]}
      content={
        <Stack gap={2}>
          <Text variant="body2">
            Are you sure you want to delete {user.firstName} {user.lastName}?
          </Text>
          <Text variant="body3" sx={{ color: COLORS.P_MED_LOW_EMPHASIS }}>
            This action cannot be undone.
          </Text>
        </Stack>
      }
      ctaOrientation="horizontal"
    />
  );
}
